import { z } from 'zod';
import { postRequest } from './amplify/helpers';

const DownloadSchema = z.object({
  s3Key: z.string(),
  s3Bucket: z.string().optional(),
  filename: z.string().optional(),
});

export const getDownloadUrl = async (body: z.infer<typeof DownloadSchema>): Promise<{ signedUrl: string }> =>
  postRequest({
    apiName: 'studio',
    path: '/download',
    options: { body },
  });
